import { render, staticRenderFns } from "./ManageResources.vue?vue&type=template&id=61ba834c&scoped=true"
import script from "./ManageResources.vue?vue&type=script&lang=js"
export * from "./ManageResources.vue?vue&type=script&lang=js"
import style0 from "./ManageResources.vue?vue&type=style&index=0&id=61ba834c&prod&lang=css"
import style1 from "./ManageResources.vue?vue&type=style&index=1&id=61ba834c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba834c",
  null
  
)

export default component.exports